<template>
    <div class="details-page" v-if="tripDetails != null">
        <div class="md-layout">
            <div class="md-layout-item">
                <div class="custom-toolbar">
                    <div class="custom-toolbar-end" v-if="!$root.isMobileOnly && !isReadOnlyUser">
                        <div class="header-button-container">
                            <trip-status-button
                                :trip="tripDetails"
                                :is-modal="false"
                                @statusUpdated="handleChangedTripStatus"
                                @statusHistoryUpdated="handleTripStatusHistoryUpdated"
                                class-name="md-sm"
                                class="status-btn"
                            />
                            <md-button title="Reassign Trip" @click.stop="reassignTrip">
                                <span>Reassign Trip</span>
                            </md-button>
                            <md-button title="Edit trip details" @click.stop="handleTripUpdate">
                                <span>Edit</span>
                            </md-button>
                            <generate-label-button
                                v-if="tripDetails.stopList.length > 0"
                                :id="tripDetails.tripId"
                                :use-icon="false"
                                :type="'Trip'"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="md-layout md-alignment-top-left content-layout-panel">
            <div
                class="md-layout-item md-small-size-100 md-medium-size-100 md-layout md-large-size-66 md-xlarge-size-50"
            >
                <div class="md-layout-item md-large-size-100 md-medium-size-100 md-small-size-100 md-xlarge-size-100">
                    <md-card>
                        <md-card-header class="md-card-header-icon md-card-header-blue">
                            <div class="card-icon" v-if="tripDetails.assignedTo.photoUrl === null">
                                <md-icon>description</md-icon>
                            </div>
                            <div class="card-icon profile-image" v-if="tripDetails.assignedTo.photoUrl !== null">
                                <img
                                    :src="tripDetails.assignedTo.photoUrl"
                                    @error="$_setDefaultBrokenImage"
                                    alt="avatar"
                                />
                            </div>
                        </md-card-header>

                        <md-card-content>
                            <div class="single-row three-column-box">
                                <div class="custom-md-field details-box">
                                    <div class="custom-label">Driver</div>
                                    <router-link
                                        v-if="tripDetails.assignedTo.publicUserId"
                                        :to="{
                                            name: 'Team Member Profile',
                                            params: { publicUserId: tripDetails.assignedTo.publicUserId }
                                        }"
                                        target="_blank"
                                    >
                                        {{ tripDetails.assignedTo.fullName || tripDetails.assignedTo.publicUserId }}
                                    </router-link>
                                    <a v-else title="Reassign Trip" @click.stop="reassignTrip">Unassigned</a>
                                </div>
                                <div
                                    class="details-box"
                                    v-if="
                                        !tripDetails.rateGroupId &&
                                            tripDetails.assignedTo.rateGroupId &&
                                            showServicePackage()
                                    "
                                >
                                    <label>Driver Service Package</label>
                                    <span class="value">
                                        {{ tripDetails.assignedTo.rateGroupName }}
                                    </span>
                                </div>
                                <div class="details-box">
                                    <label>Trip Date</label>
                                    <span class="value">
                                        {{ tripDetails.tripDate | dateFormat(DATE_TYPES.standardDate) }}
                                    </span>
                                </div>
                                <div class="details-box" v-if="tripDetails.completedDate">
                                    <label>Completed Date</label>
                                    <span class="value">
                                        {{ tripDetails.completedDate | dateTimeFormat(DATE_TYPES.standardDate) }}
                                    </span>
                                </div>
                            </div>
                            <div class="single-row three-column-box">
                                <div v-if="tripDetails.startTime" class="details-box">
                                    <label>Start Time</label>
                                    <span>
                                        {{ convertTimeFormat(tripDetails.startTime) }}
                                    </span>
                                </div>
                                <div v-if="tripDetails.actualStartTime" class="details-box">
                                    <label>Actual Start Time</label>
                                    <span>
                                        {{ tripDetails.actualStartTime | dateTimeFormat(DATE_TYPES.standardDate) }}
                                    </span>
                                </div>
                                <div class="details-box">
                                    <label>Start Location</label>
                                    <span>{{ tripDetails.locationDetails.startAddress }}</span>
                                </div>
                            </div>
                            <div class="single-row three-column-box">
                                <div v-if="tripDetails.endTime" class="details-box">
                                    <label v-if="tripDetails.endTime != null">End Time</label>
                                    <span v-if="tripDetails.endTime != null">
                                        {{ convertTimeFormat(tripDetails.endTime) }}
                                    </span>
                                </div>
                                <div
                                    v-if="tripDetails.actualEndTime && tripDetails.status === 'Complete'"
                                    class="details-box"
                                >
                                    <label>Actual End Time</label>
                                    <span>
                                        {{ tripDetails.actualEndTime | dateTimeFormat(DATE_TYPES.standardDate) }}
                                    </span>
                                </div>
                                <div class="details-box">
                                    <label v-if="tripDetails.locationDetails.endAddress != null">End Location</label>
                                    <span v-if="tripDetails.locationDetails.endAddress != null">
                                        {{ tripDetails.locationDetails.endAddress }}
                                    </span>
                                </div>
                            </div>
                            <div v-if="teamRegionName" class="single-row">
                                <div class="details-box">
                                    <label>Team Region</label>
                                    <span>{{ teamRegionName }}</span>
                                </div>
                            </div>
                            <div
                                v-if="tripDetails.rateGroupName || showRunScheduleInfo"
                                :class="servicePackageRowClass"
                            >
                                <div class="details-box" v-if="tripDetails.rateGroupName">
                                    <label>Service Package</label>
                                    <span>{{ tripDetails.rateGroupName }}</span>
                                </div>
                                <div class="details-box" v-if="showRunScheduleInfo">
                                    <label>Run Schedule (Run Number)</label>
                                    <span>{{ formattedRunScheduleList }}</span>
                                </div>
                            </div>

                            <div v-if="tripDetails.customerInvoiceId" class="details-box">
                                <label class="label">Customer Invoice:</label>

                                <span class="value">
                                    <div
                                        :class="
                                            `custom-badge payment-status-${tripDetails.customerInvoiceStatus
                                                .toLowerCase()
                                                .replace(/\s+/g, '')}`
                                        "
                                    >
                                        {{ $t('inputs.paymentStatuses.' + tripDetails.customerInvoiceStatus) }}
                                    </div>

                                    <router-link
                                        :to="{
                                            name: 'Customer Invoice Details',
                                            params: { invoiceId: tripDetails.customerInvoiceId }
                                        }"
                                        target="_blank"
                                    >
                                        {{ tripDetails.customerInvoiceNumber }}
                                    </router-link>
                                </span>
                            </div>

                            <div v-if="tripDetails.teamMemberInvoiceId" class="details-box">
                                <label class="label">Team Member Invoice:</label>

                                <span class="value">
                                    <div
                                        :class="
                                            `custom-badge payment-status-${tripDetails.teamMemberInvoiceStatus
                                                .toLowerCase()
                                                .replace(/\s+/g, '')}`
                                        "
                                    >
                                        {{ $t('inputs.paymentStatuses.' + tripDetails.teamMemberInvoiceStatus) }}
                                    </div>

                                    <router-link
                                        :to="{
                                            name: 'Team Member Invoice Details',
                                            params: { invoiceId: tripDetails.teamMemberInvoiceId }
                                        }"
                                        target="_blank"
                                    >
                                        {{ tripDetails.teamMemberInvoiceNumber }}
                                    </router-link>
                                </span>
                            </div>
                        </md-card-content>
                    </md-card>
                </div>

                <div class="md-layout-item md-small-size-100 md-large-size-100 md-xlarge-size-100 map-box">
                    <map-box-overlay
                        :details="tripDetails"
                        :type="'trip'"
                        :clicked-history="clickedHistory"
                    ></map-box-overlay>
                </div>

                <div
                    class="md-layout-item md-small-size-100 md-large-size-100 md-xlarge-size-100 md-xsmall-hide md-small-hide- md-medium-hide md-large-hide"
                >
                    <notes :list="tripDetails.notes" :trip-id="tripDetails.tripId" @notesAdded="handleAddedTripNote" />
                </div>

                <div class="md-layout-item md-small-size-100 md-large-size-100 md-xlarge-size-100 md-xlarge-hide">
                    <stop-list-table :trip-details="stopListData" />
                </div>
                <div
                    v-if="tripDetails.driverBreakList && tripDetails.driverBreakList.length > 0"
                    class="md-layout-item md-small-size-100 md-large-size-100 md-xlarge-size-100 md-xlarge-hide"
                >
                    <driver-break-list-table :trip-details="stopListData" />
                </div>
                <div
                    v-if="canViewHistory"
                    class="md-layout-item md-small-size-100 md-large-size-100 md-xlarge-size-100"
                >
                    <md-card class="history-section">
                        <md-card-content>
                            <history-component
                                ref="historyComponent"
                                :view-type="CHANGE_HISTORY_VIEW_TYPES.TRIP"
                                :entity-id="tripDetails.tripId"
                                :page-size="15"
                                title="Trip Change History"
                            />
                        </md-card-content>
                    </md-card>
                </div>
            </div>

            <div
                class="md-layout-item md-small-size-100 md-layout md-medium-size-100 md-large-size-33 md-xlarge-size-50"
            >
                <div
                    v-if="tripDetails.contact"
                    class="md-layout-item md-small-size-100 md-medium-size-50 md-large-size-100 md-xlarge-size-50 md-xlarge-hide"
                >
                    <trip-contact-details :trip-details="tripDetails" />
                </div>
                <div
                    class="md-layout-item md-small-size-100 md-medium-size-50 md-large-size-100 md-xlarge-size-50 md-xlarge-hide"
                >
                    <assignment-history-timeline :list="tripDetails.tripUserHistory" />
                </div>
                <div
                    class="md-layout-item md-small-size-100 md-medium-size-50 md-large-size-100 md-xlarge-size-50 md-xlarge-hide"
                >
                    <md-card>
                        <md-card-header class="md-card-header-icon md-card-header-warning">
                            <div class="card-icon">
                                <md-icon>history</md-icon>
                            </div>
                        </md-card-header>

                        <md-card-content>
                            <time-line plain type="simple" v-if="tripDetails.statusHistory.length > 0">
                                <time-line-item
                                    inverted
                                    :badge-type="`status-${history.newStatus.toLowerCase().replace(/\s+/g, '')}`"
                                    badge-icon="place"
                                    v-for="(history, index) in tripDetails.statusHistory"
                                    :key="index"
                                    :is-clickable="true"
                                    @clicked="showHistoryInMap(history)"
                                >
                                    <span
                                        slot="header"
                                        class="badge"
                                        :class="`status-${history.newStatus.toLowerCase().replace(/\s+/g, '')}`"
                                    >
                                        {{ history.newStatus }}
                                    </span>

                                    <span slot="headerTime" class="time">
                                        {{ history.actionDate | dateTimeFormat(DATE_TYPES.standardDate) }}
                                    </span>

                                    <h6 slot="footer">
                                        <i class="ti-time" />

                                        By {{ history.changedByUserFullName }}
                                    </h6>
                                </time-line-item>
                            </time-line>
                            <p v-else class="grayedout-text">No Status History Available</p>
                        </md-card-content>
                    </md-card>
                </div>
                <div class="md-layout-item md-small-size-100 md-large-size-100 md-xlarge-size-50 md-xlarge-hide">
                    <notes :list="tripDetails.notes" class="custom-note-card-large" :trip-id="tripDetails.tripId" />
                </div>
                <div
                    class="md-layout-item md-small-size-100 md-large-size-100 md-xlarge-size-100 md-xlarge-size-50 md-xsmall-hide md-small-hide- md-medium-hide md-large-hide"
                >
                    <stop-list-table :trip-details="stopListData" />
                </div>
                <div
                    v-if="tripDetails.driverBreakList && tripDetails.driverBreakList.length > 0"
                    class="md-layout-item md-small-size-100 md-large-size-100 md-xlarge-size-100 md-xlarge-size-50 md-xsmall-hide md-small-hide- md-medium-hide md-large-hide"
                >
                    <driver-break-list-table :trip-details="tripDetails" />
                </div>
                <div
                    class="md-layout-item md-small-size-100 md-medium-size-50 md-large-size-100 md-xlarge-size-50 md-xsmall-hide md-small-hide- md-medium-hide md-large-hide"
                >
                    <assignment-history-timeline :list="tripDetails.tripUserHistory" />
                </div>
                <div
                    class="md-layout-item md-small-size-100 md-medium-size-50 md-large-size-100 md-xlarge-size-50 md-xsmall-hide md-small-hide- md-medium-hide md-large-hide"
                >
                    <status-history-timeline :list="tripDetails.statusHistory" />
                </div>

                <div
                    v-if="!isIndividualUser"
                    class="md-layout-item md-small-size-100 md-large-size-100 md-xlarge-size-100"
                >
                    <trip-charge-rates-list
                        v-if="
                            (tripDetails.chargeLines.length > 0 || tripDetails.customerId || services.length > 0) &&
                                (canAccessRates || isAdmin || isReadOnlyUser)
                        "
                        :charge-lines="tripDetails.chargeLines"
                        :services="services"
                        :trip-details="tripDetails"
                        title="Trip Charges"
                        :has-invoice="tripDetails.customerInvoiceId !== null"
                        :rates-have-changed="false"
                        @updateTripDetails="handleChargesUpdated"
                    />
                </div>

                <div
                    v-if="!isIndividualUser"
                    class="md-layout-item md-small-size-100 md-large-size-100 md-xlarge-size-100"
                >
                    <trip-cost-rates-list
                        v-if="
                            (tripDetails.costLines.length > 0 || tripDetails.publicUserId) &&
                                (canAccessRates || isAdmin)
                        "
                        :cost-lines="tripDetails.costLines"
                        :services="services"
                        :trip-details="tripDetails"
                        title="Trip Costs"
                        :has-invoice="tripDetails.teamMemberInvoiceId !== null"
                        :rates-have-changed="false"
                        @updateTripDetails="handleCostsUpdated"
                    />
                </div>

                <div class="md-layout-item md-small-size-100 md-large-size-100 md-xlarge-size-100">
                    <trip-services
                        :services="services"
                        :is-invoiced="
                            tripDetails.customerInvoiceId !== null || tripDetails.teamMemberInvoiceId !== null
                        "
                        :trip-id="tripDetails.tripId"
                        @serviceUpdated="handleServicesUpdated"
                    />
                </div>
                <div
                    v-if="!isReadOnlyUser && items.length"
                    class="md-layout-item md-small-size-100 md-large-size-100 md-xlarge-size-100"
                >
                    <trip-items :items="items" @itemUpdated="getTripDetails" />
                </div>

                <div
                    v-if="canCreateIssue"
                    v-feature="FEATURE_NAMES.IssueTracking"
                    class="md-layout-item md-small-size-100 md-large-size-100 md-xlarge-size-100"
                >
                    <review-invoice-issues
                        :issues="tripDetails.tripIssues"
                        :entity-ref="tripDetails.tripRef"
                        :entity-id="tripDetails.tripId"
                        entity-type="Trip"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { handleRequests, getTeamRegionName } from '@/helpers';
import { GeneralMixin, RatesEngineMixin } from '@/mixins';
import {
    AssignmentHistoryTimeline,
    Notes,
    StatusHistoryTimeline,
    GenerateLabelButton,
    MapBoxOverlay,
    TimeLine,
    TimeLineItem,
    ReviewInvoiceIssues,
    HistoryComponent
} from '@/components';
import moment from 'moment';
import { DATE_TYPES, FEATURE_NAMES, CHANGE_HISTORY_VIEW_TYPES } from '@/utils/constants';
import { mapGetters } from 'vuex';
import { RosteringMixin } from '@/mixins/RosteringMixin';
import StopListTable from './Components/StopListTable';
import DriverBreakListTable from './Components/DriverBreakListTable';
import TripChargeRatesList from './Components/TripChargeRatesList';
import TripCostRatesList from './Components/TripCostRatesList';
import TripContactDetails from './Components/TripContactDetails';
import TripItems from './Components/TripItems';
import TripServices from './Components/TripServices';

import UpdateTripModal from './Modals/UpdateTripModal';
import ReassignTripModal from './Modals/ReassignTripModal';
import TripStatusButton from './Buttons/TripStatusButton';

export default {
    name: 'TripDetails',
    mixins: [GeneralMixin, RatesEngineMixin, RosteringMixin],
    components: {
        AssignmentHistoryTimeline,
        Notes,
        StopListTable,
        DriverBreakListTable,
        TripStatusButton,
        StatusHistoryTimeline,
        GenerateLabelButton,
        TripChargeRatesList,
        TripCostRatesList,
        TripContactDetails,
        TripItems,
        MapBoxOverlay,
        TimeLine,
        TimeLineItem,
        TripServices,
        ReviewInvoiceIssues,
        HistoryComponent
    },
    data() {
        return {
            tripDetails: null,
            teamMembers: [],
            stopList: [],
            isAdmin: Boolean(this.$route.query.isAdmin),
            clickedHistory: {},
            items: [],
            services: [],
            FEATURE_NAMES,
            CHANGE_HISTORY_VIEW_TYPES
        };
    },
    async created() {
        this.$_handleLoaderState(true);
        await this.getTripDetails();
        await this.getTeamMembers();
        this.$_handleLoaderState(false);
    },
    computed: {
        ...mapGetters({
            isReadOnlyUser: 'user/isReadOnlyUser',
            teamRegions: 'team/teamRegions',
            isTeamOwner: 'user/isTeamOwner',
            isIndividualUser: 'user/isIndividualUser',
            canCreateIssue: 'user/canCreateIssue',
            canAccessRates: 'user/canAccessRates'
        }),
        teamRegionName() {
            return getTeamRegionName(this.tripDetails?.teamRegionId, this.teamRegions);
        },
        showRunScheduleInfo() {
            return !!(this.tripDetails && this.tripDetails.createdFromRunScheduleId);
        },
        formattedRunScheduleList() {
            if (!this.showRunScheduleInfo) 
                return '';
            const runs = this.tripDetails?.tripRuns || [];
            return runs.map((r) => `${r.runName} (${r.runNumber})`).join(', ');
        },
        servicePackageRowClass() {
            return this.showRunScheduleInfo ? 'single-row' : 'single-row';
        },
        canViewHistory() {
            return this.isTeamOwner || this.$store.getters['user/isTeamManager'];
        }
    },
    methods: {
        async getTeamMembers() {
            this.teamMembers = await this.$store.dispatch('team/FETCH_TEAM_MEMBERS');
        },
        async getTripDetails() {
            const qry = new URLSearchParams();
            qry.append('includeNotes', true);
            qry.append('includeUserHistory', true);
            qry.append('includeStops', true);
            qry.append('includeStopLines', true);
            qry.append('includeAssignedUser', true);
            qry.append('includeStatusHistory', true);

            const api = `/api/trips/${this.$route.params.tripId}/details?${qry}`;
            const {
                data: { data }
            } = await handleRequests(api);

            this.tripDetails = data;
            this.tripDetails.user = data.assignedTo;
            this.stopListData = data;
            this.includeTripStartEnd(this.stopListData.stopList, data);
            this.items = this.getItems(this.stopListData.stopList);
            this.getServices();
        },
        getItems(stopList) {
            const items = [];
            if (!stopList || !stopList.length) 
                return items;

            for (let i = 0; i < stopList.length; i++) {
                const stop = stopList[i];

                if (stop.lines?.length) {
                    for (let j = 0; j < stop.lines.length; j++) {
                        const line = stop.lines[j];

                        if (line.itemId && !items.some((i) => i.itemId === line.itemId)) {
                            const tripItem = this.getTripItem(line, stop);
                            items.push(tripItem);
                        }
                    }
                }
            }

            return items;
        },
        getTripItem(item, stop) {
            item.stopStatus = item.status;
            item.stopDetails = {
                stopRef: stop.stopRef,
                sourceReference: stop.sourceReference,
                isInvoiced: stop.teamMemberInvoiceId !== null || stop.customerInvoiceId !== null
            };
            item.shipmentDetails = {
                shipmentId: stop.shipment.shipmentId,
                shipmentRef: stop.shipment.shipmentRef,
                sourceReference: stop.shipment.sourceReference
            };

            return item;
        },
        handleTripUpdate() {
            const { tripId } = this.$route.params;

            this.$modal
                .show(UpdateTripModal, {
                    // eslint-disable-next-line radix
                    tripId: parseInt(tripId)
                })
                .then(async (response) => {
                    if (response.code === 'ok') {
                        this.$modal.hide();
                        this.$_handleLoaderState(true);
                        await this.getTripDetails();
                        this.$_handleLoaderState(false);
                        this.refreshHistory();
                    }
                });
        },
        handleChangedTripStatus(response) {
            const { status } = response;
            this.$set(this.tripDetails, 'status', status);
            this.refreshHistory();
        },
        handleTripStatusHistoryUpdated({ stopId, oldStatus, newStatus }) {
            this.tripDetails.statusHistory.push({
                actionDate: moment().format(),
                changedByUserFullName: this.tripDetails.user.fullName,
                location: null,
                oldStatus,
                newStatus
            });
        },
        includeTripStartEnd(stopList, data) {
            if (stopList.length === 0) 
                return;

            const assignedUser = stopList[0].assignedTo;
            const startTripStop = {
                stopId: 0,
                stopRef: '',
                actualDate: data.actualStartTime,
                originalEta: data.locationDetails.startEta,
                location: data.locationDetails.startLocation,
                address: data.locationDetails.startAddress,
                assignedTo: assignedUser,
                isStartStop: true,
                status: ''
            };
            this.stopListData.stopList.splice(0, 0, startTripStop);
            const endTripStop = {
                stopId: 0,
                stopRef: '',
                actualDate: data.actualEndTime,
                originalEta: data.locationDetails.endEta,
                location: data.locationDetails.endLocation,
                address: data.locationDetails.endAddress || 'Estimated Completion',
                assignedTo: assignedUser,
                isEndStop: true,
                status: ''
            };

            this.stopListData.stopList.splice(this.stopListData.stopList.length, 0, endTripStop);
        },
        reassignTrip() {
            const { tripId } = this.$route.params;
            const { publicUserId } = this.tripDetails;
            let { tripDate } = this.tripDetails;
            tripDate = moment(tripDate).format(DATE_TYPES.internationalDate);

            this.$modal
                .show(ReassignTripModal, {
                    // eslint-disable-next-line radix
                    tripId: parseInt(tripId),
                    teamMembers: this.teamMembers,
                    assignedTo: publicUserId,
                    tripDate,
                    teamRegionId: this.tripDetails.teamRegionId,
                    displayAvailabilityIndicator: this.$_canDisplayAvailabilityIndicators(true, tripDate)
                })
                .then(async (response) => {
                    if (response.code === 'ok') {
                        this.$_handleLoaderState(true);
                        await this.getTripDetails();
                        this.$_handleLoaderState(false);
                        this.refreshHistory();
                    }
                });
        },
        convertTimeFormat(time) {
            if (time != null) 
                return moment(time, 'LT').format('LT');
            return null;
        },
        async handleAddedTripNote() {
            await this.refreshNoteList();
        },
        async refreshNoteList() {
            const api = `/api/trips/${this.tripDetails.tripId}/notes`;
            const result = await handleRequests(api);
            this.tripDetails.notes = result.data;
        },
        showServicePackage() {
            // eslint-disable-next-line no-bitwise
            if (this.tripDetails.assignedTo.applyRatesTo & this.getKeyByLabelInApplyRatesTo('Trip')) {
                return true;
            }

            return false;
        },
        showHistoryInMap(history) {
            const { actionDate, newStatus } = history;
            this.clickedHistory = { status: newStatus.toLowerCase(), actionDate };
        },
        async getServices() {
            const api = `/api/trips/${this.$route.params.tripId}/services`;
            const response = await handleRequests(api, { method: 'POST' });
            this.services = response.data;
        },
        refreshHistory() {
            // Delay refresh to allow CDC to capture the changes before querying
            setTimeout(() => {
                if (this.$refs.historyComponent && typeof this.$refs.historyComponent.refresh === 'function') {
                    this.$refs.historyComponent.refresh();
                }
            }, 3000);
        },
        async handleChargesUpdated() {
            await this.getTripDetails();
            this.refreshHistory();
        },
        async handleCostsUpdated() {
            await this.getTripDetails();
            this.refreshHistory();
        },
        async handleServicesUpdated() {
            await this.getServices();
            this.refreshHistory();
        }
    }
};
</script>

<style lang="scss" scoped>
$status-pending: #c2907f;
$status-enroute: #4ed2ff;
$status-arrived: #2b93ff;
$status-departed: #ffb42b;
$status-cancelled: #ff5245;
$status-delayed: #384553;
$status-complete: #0bda8e;
.content-layout-panel {
    > div {
        padding: 0;
    }
}

.details-box {
    display: inline-block;
    vertical-align: top;
    min-width: 150px;
}

.profile-image {
    height: 63px;
    width: 63px;
    padding: 0px !important;
    -webkit-box-shadow: 0 12px 20px -10px rgba(0, 0, 0, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12),
        0 7px 8px -5px rgba(0, 0, 0, 0.2) !important;
    box-shadow: 0 12px 20px -10px rgba(0, 0, 0, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12),
        0 7px 8px -5px rgba(0, 0, 0, 0.2) !important;
    img {
        border-radius: 3px;
    }
}

.custom-md-field {
    a {
        color: #0076f0;
        cursor: pointer;
    }
}

.custom-note-card-large {
    ::v-deep .md-card-content > div {
        max-height: 661px;
        overflow: auto;
    }
}

.single-row {
    > div:first-child {
        width: 20%;
    }
    > div:last-child {
        width: 80%;
    }
}

.three-column-box {
    > div:first-child {
        width: 20%;
    }
    > div:nth-child(2) {
        width: 20%;
    }
    > div:last-child {
        width: 40%;
    }
}

.status-btn {
    display: inline-block;
    text-transform: uppercase;
    font-size: 12px;
    margin: 6px 0px;
    height: 36px;
    line-height: 36px;
    border-radius: 2px;

    ::v-deep span {
        height: 36px;
        line-height: 36px;
    }

    > ::v-deep .dropdown-menu {
        margin-left: 9px;
        margin-top: 0;
    }
}

.details-page {
    .title {
        font-size: 18px;
    }

    .status-pending {
        background-color: $status-pending !important;
        color: #fff !important;
    }

    .status-pending:hover,
    .status-pending:focus {
        color: #fff !important;
    }

    .status-enroute {
        background-color: $status-enroute !important;
    }

    .status-arrived {
        background-color: $status-arrived !important;
    }

    .status-departed {
        background-color: $status-departed !important;
    }

    .status-complete {
        background-color: $status-complete !important;
    }

    .status-delayed {
        background-color: $status-delayed !important;
    }

    .status-cancelled {
        background-color: $status-cancelled !important;
    }

    ::v-deep .badge {
        display: inline-block;
        border-radius: 12px;
        padding: 5px 12px;
        text-transform: uppercase;
        font-size: 10px;
        color: #fff;
        font-weight: 500;
        line-height: 1;
        text-align: center;
        white-space: nowrap;
        vertical-align: baseline;
        position: initial;
        width: initial;
        height: initial;
        top: initial;
        right: initial;
        margin-top: initial;
        margin-right: initial;
        max-width: 100%;
        text-overflow: ellipsis;
        overflow: hidden;
    }

    ::v-deep .timeline.timeline-simple {
        margin-top: 0;
    }

    ::v-deep .md-card-timeline {
        margin-top: 0;
        margin-bottom: 0;
    }

    ::v-deep .timeline > li > .timeline-panel {
        padding: 5px 20px;
        background-color: #fafafa;
    }

    ::v-deep .timeline-panel > h6 > h6 {
        text-transform: none;
        margin-top: 0;
    }

    ::v-deep .timeline-panel > h6 {
        margin-top: 0px;
    }

    ::v-deep .timeline-heading {
        margin-bottom: 5px;
    }

    ::v-deep .timeline > li {
        margin-bottom: 5px;
    }

    ::v-deep .timeline > li > .timeline-panel:after,
    ::v-deep .timeline > li > .timeline-panel:before {
        border-left-color: #fafafa;
        border-right-color: #fafafa;
    }

    ::v-deep .timeline.timeline-simple > li > .timeline-panel {
        width: 83%;
    }

    ::v-deep .timeline-heading .time {
        margin-left: 10px;
        color: #333333;
        font-weight: 400;
        font-size: 0.75rem;
    }

    .stop-notes {
        white-space: pre-wrap;
    }
}
</style>
